import Form from 'components/Form';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';
import MuiTextField from 'components/Form/MuiTextField';

import RowContainer from '../components/RowContainer';
import RowContent from '../components/RowContent';
import SectionTitle from '../components/SectionTitle';
import { Box, Stack } from '@mui/system';

interface Props extends IFormRegister, IFormValues, IFormWatch {
  disabled?: boolean;
  name: string;
  gender: number;
}

const StaffInfo = (props: Props) => {
  const { disabled, watch, setValue, name, getValues, gender } = props;

  const rows = [
    { title: '성명', variable: 'info_name', type: 'label' },
    { title: '직번', variable: 'info_no', type: 'text' },
    { title: '연락처', variable: 'info_contact', type: 'text' },
    { title: '입사일자', variable: 'info_date', type: 'date' },
    { title: '근무부서', variable: 'info_department', type: 'text' },
    {
      title: '직종',
      variable: 'info_job',
      type: 'text',
    },
    { title: '성별', variable: 'info_gender', type: 'gender' },
    { title: '임신여부', variable: 'info_pregnancy', type: 'pregnancy' },
  ];

  return (
    <>
      <SectionTitle title="1. 직원의 인적사항" mb={2} />

      <RowContainer xs={12}>
        {rows.map(({ title, variable, type }) => (
          <RowContent
            key={variable}
            title={title}
            titleRatio={1}
            childrenRatio={2}
          >
            {type === 'text' && (
              <MuiTextField
                value={watch(`${variable}`)}
                onChange={e => setValue(variable, e.target.value)}
                required={false}
                disabled={disabled}
              />
            )}
            {type === 'label' && (
              <Form.MuiTextField
                disabled={disabled}
                value={name}
                InputProps={{ readOnly: true }}
                sx={{ backgroundColor: 'lightgray' }}
              />
            )}
            {type === 'date' && (
              <MuiTextField
                type="date"
                value={watch(`${variable}`)}
                onChange={e => setValue(variable, e.target.value)}
                required={false}
                disabled={disabled}
              />
            )}
            {type === 'gender' && (
              <Box sx={{ marginLeft: '-10px' }}>
                <Form.MuiRadioGroup
                  i18nKey="GENDER"
                  values={[1, 2]}
                  value={Number(gender)}
                  defaultValue={getValues(variable)}
                  onChange={v => {
                    setValue(variable, Number(v));
                  }}
                />
              </Box>
            )}
            {type === 'pregnancy' && (
              <Stack direction="row" sx={{ marginLeft: '-10px' }}>
                <Form.MuiRadioGroup
                  i18nKey="YESORNOEN"
                  values={[1, 2]}
                  defaultValue={getValues('info_pregnancy')}
                  onChange={v => {
                    setValue('info_pregnancy', Number(v));
                  }}
                  width={'50px'}
                />
                <MuiTextField
                  value={watch('info_pregnancy_input')}
                  onChange={e =>
                    setValue('info_pregnancy_input', e.target.value)
                  }
                  placeholder="주수"
                  required={false}
                  disabled={disabled}
                  sx={{ marginLeft: '10px' }}
                />
              </Stack>
            )}
          </RowContent>
        ))}
      </RowContainer>
    </>
  );
};

export default StaffInfo;
